import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import Journey from './Journey';


const CreditCardDocument = types
    .model('CreditCardDocument', {
        id: types.optional(types.identifier, uuid),
        journey: Journey,
        schemaVersion: 2,
    });

export default CreditCardDocument;
